import { usePersistentStorage } from '@/hooks/usePersistentStorage';
import { getAuthCodeLogin } from '@simplywallst/services';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * Attempts to login a user using an auth code.
 *
 * Will no-op if a user ID froma  previous session cannot be found, or a code is unavailable.
 */
export const useAuthCodeLogin = ({
  code,
  enabled,
  onResolve,
}: {
  code: string | undefined;
  enabled: boolean;
  onResolve: (
    data: Prettify<Awaited<ReturnType<typeof getAuthCodeLogin>>>
  ) => void;
}) => {
  const storage = usePersistentStorage();

  const query = useQuery({
    queryKey: ['authCodeLogin', code],
    queryFn: async () => {
      const userID = await storage.get('_sws_suid');

      if (code === undefined || userID === null || userID === undefined) {
        return undefined;
      }

      const data = await getAuthCodeLogin(userID, code);
      return data;
    },
    enabled: enabled && code !== undefined,
    retry: false,
  });

  useEffect(() => {
    if (query.data !== undefined) {
      onResolve(query.data);
    }
  }, [query.data, onResolve]);

  return {
    isLoading: query.isFetching,
  };
};
